module.exports = __webpack_public_path__ + "media/mii-swordfighter.7167d840.wav";